import createClient, { type ClientOptions } from 'openapi-fetch';
import { fetchWithSessionCookieAuth } from './auth';
import { projectIpRestrictionMiddleware } from './projectIpRestriction';

export const createQantApiClient = <Paths extends {}>(options: Omit<ClientOptions, 'fetch'> = {}) => {
  const client = createClient<Paths>({ ...options, fetch: fetchWithSessionCookieAuth });
  client.use(projectIpRestrictionMiddleware);
  return client;
};
